import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { ROUTES } from 'routes'
import { Schema } from '../../schema'
import { CONFIRM_RESET_PASSWORD, Data } from './api'
import { UseConfirmResetPassword } from './types'

export const useConfirmResetPassword = (): UseConfirmResetPassword => {
  const navigate = useNavigate()
  const { t } = useTranslation('features/user')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending, mutateAsync } = useMutation<{ input: Schema }, Data>({
    mutation: CONFIRM_RESET_PASSWORD,
    onCompleted: async data => {
      const { confirmResetPassword } = data

      // TODO: 'confirmResetPassword' should never be null in API response. Backend needs to be fixed.
      if (confirmResetPassword?.errors && confirmResetPassword?.errors.length > 0) {
        setErrors(mapGraphQLErrors(confirmResetPassword.errors))
      } else {
        setErrors({})

        navigate(ROUTES.AUTH.LOGIN)
        enqueueSnackbar(t('confirmResetPassword.form.success'), {
          variant: 'success',
        })
      }
    },
  })

  const confirmResetPassword = (data: Schema): void => {
    void mutateAsync({
      input: data,
    })
  }

  return {
    confirmResetPassword,
    errors,
    loading: isPending,
  }
}
